import React, { useState, useRef, useEffect } from 'react';
import Skill from './Skill';
import Reveal from './Reveal';
import { motion, AnimatePresence }from 'framer-motion';

const SkillBox = (props) => {
    const [accordion, setAccordion] = useState(false);
    return (
        <Reveal className='w-[80%] h-fit flex flex-col justify-center items-center'>
            <div className='w-full h-fit bg-gray-400 rounded-[30px] bg-clip-padding backdrop-filter backdrop-blur-lg bg-opacity-20 border border-gray-100 px-10 py-8 neumorphism'>
                <div className='flex flex-row justify-between items-center gap-10'>
                    <h1 className='text-white text-4xl font-poppins font-bold text-center'>{props.title}</h1>
                    <button className='text-white text-4xl font-poppins font-bold text-center' onClick={() => setAccordion(!accordion)}>{accordion ? '-' : '+'}</button>
                </div>
                <AnimatePresence initial={false}>
                {accordion && 
                    <motion.div
                        className=' w-full gap-10 flex flex-wrap justify-center items-center'
                        variants={{
                            open: { opacity: 1, height: "fit-content" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        initial= "collapsed"
                        animate= "open"
                        exit= "collapsed"
                        transition={{ duration: 0.1, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        {props.skills.map((skill, index) => {
                            return <Skill name={skill.name} rate={skill.rate} src={skill.src} key={index} />;
                        })}
                    </motion.div>}
                </AnimatePresence>
            </div>
        </Reveal>
    );
};

export default SkillBox;
